/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
<template>
  <div>
    <div>
      <div class="commonNavBox breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item >搜索结果</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="productBox">
      <div class="productListBox">
        <div
          class="productListPart"
        >
          <div class="productList">
            <div
              class="productItem"
              v-for="(productItem, productIndex) in productList"
              :key="productIndex"
              @click="goProductDetail(productItem)"
            >
              <img class="productImg" :src="$imgUrl.imgUrl(productItem.thumb)" alt="" />
              <div class="textArea">
                <div class="textAbbreviation2 productName">
                  {{ productItem.title }}
                </div>
                <div div class="productDec">{{ productItem.keywords }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="pagination">
					<el-pagination
						background
						layout="prev, pager, next"
					:total="1000">
					</el-pagination>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
export default {
  data() {
    return {     
      productList: [
        
      ],
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.query.keywords) {
          this.keywords = val.query.keywords;
          setTimeout(() => {
            this.getProductList(val.query.keywords);
          }, 500);
        }
        
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    var search  = this.$route.query.keywords;
    this.getProductList(search);
  },
  mounted() {
   
  },
  methods: {
    linkUrl(url) {
      window.location.href = url;
    },

    getProductList(search) {
      axios.get("/api/product/list",{search:search}).then((res) => {
        if (res.code == 1) {
            this.productList=res.data
            if(res.msg){
              this.$message({
                message: res.msg,
                offset:200,
                type: "success",
              }); 
            }     
        }
      });
    },
    goProductDetail(item) {
      this.$router.push({ name: "productDetail", query: {id:item.id,catid:item.catid} });
    },
   
  },
};
</script>
<style scoped>
/* 产品 场景 */
.el-select {
  width: 100%;
}
/deep/.el-breadcrumb__inner{color: #000;}
/deep/.breadcrumb .el-breadcrumb{width: 73vw; font-size: 16px;font-weight: bold;color: #000!important;}
/deep/.el-form-item__label {
  color: #333;
  font-weight: bold;
}
/deep/.codeBox .el-input {
  width: 300px;
  vertical-align: middle;
}
.sxBtn {
  position: absolute;
  left: 270px;
  width: 22px;
  height: 19px;
  top: 10px;
}
/* .codeImg {
  width: 99px;
  height: 38px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
} */
.newsBg span,
.newsBg strong {
  color: white;
  line-height: 22px;
}
.newsBg strong {
  width: auto;
}
.sortNav {
  width: 1400px;
  height: 130px;
  background: #fbfbfb;
  border-radius: 12px;
  position: absolute;
  left: 50%;
  bottom: -90px;
  margin-left: -700px;
}
/* .productNavBox,
.secondaryNavBox {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  overflow-x: auto;
} */
/* .productNavList,
.secondaryNavList {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 67px;
  position: relative;
  padding: 0 30px;
}
.productNavList .text {
  font-size: 14px;
  color: #666666;
}
.productNavList .line {
  display: none;
} */
.navSelected .text {
  font-weight: bold;
  color: #010101;
}
.navSelected .line {
  display: block;
  width: 54px;
  height: 2px;
  background: #267fe9;
  position: absolute;
  bottom: 0px;
}
/* .secondaryNavList {
  height: 60px;
}
.secondaryNavList .text {
  font-size: 14px;
  color: #666666;
} */
/* .secondarySelected .text {
  color: #267fe9;
} */
.productBox {
  min-height: 44.2vh;
  /* padding-top: 90px; */
  padding-bottom: 20px;
  box-sizing: border-box;
}
.productListBox {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  padding: 0 8px;
  box-sizing: border-box;
}

.productImg {
  width: 100%;
  height: 332px;
  /* border-radius: 10px; */
}
.productName {
  font-size: 16px;
  font-family: Helvetica Neue;
  font-weight: 400;
  color: #333;
  line-height: 32px;
  margin-top: 12px;
}
.productDec {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  /* line-height: 42px; */
}
.textArea {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
}
.pagination {
  margin-top: 20px;
}

.navBox {
  justify-content: flex-start;
  padding: 0 180px;
  box-sizing: border-box;
}
.navBox {
  margin-bottom: 20px;
}
.productListBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* padding: 0 220px; */
  box-sizing: border-box;
  overflow-x: auto;
  width: 78%;
}
.productListPart {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  margin-top:20px;
}
.productList {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
}
.productItem {
  width: 23%;
  height: 428px;
  box-sizing: border-box;
  transition: color 0.5s;
  -webkit-transition: color 0.5s;
  /* margin: 0 12px 16px 12px; */
}
.productItem:hover {
  box-shadow: 0px 0px 23px 1px rgba(95, 95, 95, 0.18);
  -webkit-transition: color 0.5s;
}
/* .productList:hover .productNmae {
  color: #267fe9;
} */
.productItem:not(:nth-child(4n)) {
  margin-right: calc(8% / 3);
  margin-bottom: 16px;
}
.className {
  width: 100%;
  margin-top: 40px;
  margin-bottom: 47px;
  flex-shrink: 0;
  font-weight: bold;
  color: #333;
  font-size: 18px;
}
</style>

